import axios from 'axios';
import { accountStore } from '@/account/store';
import { router } from '@/account/router';

export default function setup() {
    axios.interceptors.request.use(function (config) {
        const token = accountStore.getters.token;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    }, function (err) {
        return Promise.reject(err);
    });

    axios.interceptors.response.use((res) => {
  
        return res;
    },
        async function (error) {
            // Any status codes that falls outside the range of 2xx cause this function to trigger
            // Do something with response error

            const originalRequest = error.config;
            if (

                //We force the user logged out because there details have expired...
                error.response.status === 401) {
          
                accountStore.commit("logout");
                router.push("/account/#/login");
                return Promise.reject(error);
            } else if (error.response.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;
          //      accountStore.dispatch("refresh", refreshToken).then(() => {
                    return axios(originalRequest);

                //}).catch(() => {
                //    return Promise.reject(error);
                //});
            }
            return Promise.reject(error);
        }
    );
}

//if (
//    error.response.status === 401
//        && originalRequest.url.includes("auth/jwt/refresh/")) {
//    accountStore.commit("logout");
//    router.push("/account/#/login");
//    return Promise.reject(error);
//} else if (error.response.status === 401 && !originalRequest._retry) {
//    originalRequest._retry = true;
//    await accountStore.dispatch("refresh");
//    return axios(originalRequest);
//}